/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements } from '../block_compatibility_checks';

/*
* C-Block dropdown for selecting radar data
*/
Blockly.Blocks['input_radar_data_only'] = {
    init: function () {
        this.appendDummyInput('inp')
            .appendField("Radar: ")
            .appendField(new Blockly.FieldDropdown([["PALSAR Yearly Mosaic", "PALSAR"], ["Sentinel-1 SAR GRD", "SAR"]]), 'dropdown')
            .appendField(new Blockly.FieldDropdown([["dB", "dB"], ["DN", "DN"]]), 'param');
        this.appendDummyInput('inp2')
            .appendField('Orbit:  ', 'orbit')
            .appendField(new Blockly.FieldDropdown([["Ascending", "ASCENDING"], ["Descending", "DESCENDING"], ['Both', 'BOTH']]), 'orbit_dropdown')
        this.appendStatementInput("statements", 'st')
            .setCheck(getAllowedStatements('radar_only'));
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'radar_only');
        this.setStyle('input');
        this.setTooltip(Blockly.Msg.RADAR_ONLY_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.previous_radar = 'palsar';
        this.setOnChange(function () {
            if (this.previous_radar !== this.getFieldValue('dropdown')) {
                this.updateShape_();
                this.previous_radar = this.getFieldValue('dropdown');
            }
        });
    },

    updateShape_: function () {
        var choice = this.getFieldValue('dropdown');


        if (choice == 'PALSAR') {
            let input2 = this.getInput('inp2');
            input2.removeField('orbit', true);
            input2.removeField('orbit_dropdown', true);

            let set_value = this.getField('param');
            set_value.setValue('dB');
        } else if (choice == 'SAR') {
            let set_value = this.getField('param');
            set_value.setValue('dB');
            this.getInput('inp2')
                .appendField('Orbit:  ', 'orbit')
                .appendField(new Blockly.FieldDropdown([["Ascending", "ASCENDING"], ["Descending", "DESCENDING"], ['Both', 'BOTH']]), 'orbit_dropdown')
        }
    }
};